import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class LoadCaptchaScriptService {
  load(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (!document.querySelector('[src="https://www.google.com/recaptcha/enterprise.js"]')) {
        const captcha_script = document.createElement('script');
        const key = process.env.VUE_APP_RECAPTCHA || '';
        captcha_script.src = `https://www.google.com/recaptcha/enterprise.js?render=${key}`;
        captcha_script.async = true;
        captcha_script.defer = true;
        captcha_script.onload = () => resolve();
        document.head.appendChild(captcha_script);
      } else {
        resolve();
      }
    });
  }
}
